module.exports = __webpack_public_path__ + "static/media/0324_IMG_LES_MURS_METRO_DIAMANTO_BRILLANT_NAVONA_HORIZONTALE.49637cdc.webp";